import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Platform, Dimensions } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

const AdminLayout = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState(Dimensions.get('window').width);

  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const isSmallScreen = windowWidth < 768;
  const navigation = useNavigation();
  console.log('AdminLayout navigation:', navigation);

  return Platform.OS === 'web' ? (
    <View style={[styles.container, isSmallScreen && styles.containerSmall]}>
      {!isSmallScreen && (
        <View style={styles.sidebarContainer}>
          <AdminSidebar navigation={navigation} isLayout={true} />
        </View>
      )}
      <View style={[
        styles.contentWrapper,
        isSmallScreen && styles.contentWrapperSmall
      ]}>
        <View style={styles.headerWrapper}>
          <AdminHeader navigation={navigation} />
        </View>
        <View style={styles.mainContent}>
          {children}
        </View>
      </View>
    </View>
  ) : (
    <View style={{ flex: 1 }}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F4F6',
    ...(Platform.OS === 'web' ? {
      minHeight: '100vh',
      flexDirection: 'row',
    } : {})
  },
  containerSmall: {
    flexDirection: 'column'
  },
  sidebarContainer: {
    width: 240,
    ...(Platform.OS === 'web' ? {
      position: 'fixed',
      left: 0,
      top: 0,
      bottom: 0,
      zIndex: 50,
    } : {})
  },
  contentWrapper: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    ...(Platform.OS === 'web' ? {
      marginLeft: 240,
      minHeight: '100vh',
      width: 'calc(100% - 240px)'
    } : {})
  },
  contentWrapperSmall: {
    marginLeft: 0
  },
  headerWrapper: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
    ...(Platform.OS === 'web' ? {
      position: 'sticky',
      top: 0,
      zIndex: 40
    } : {})
  },
  mainContent: {
    flex: 1,
    backgroundColor: '#F3F4F6',
    ...(Platform.OS === 'web' ? {
      minHeight: 'calc(100vh - 64px)',
      overflowY: 'auto'
    } : {}),
  }
});

export default AdminLayout;
